module.exports = __webpack_public_path__ + "img/animals_07_H.1e244e7a.jpg";